angular.module("app")
.service('SpacesService', ['$http', 'Restangular', '$rootScope', 'logService', function ($http, Restangular, $rootScope, logService) {
    function isPlaceFreeByZone(place, zone) {
        if (typeof zone.guests != "undefined") {
            for (let z = 0; z < zone.guests.length; z++) {
                if (parseInt(zone.guests[z].prefered) === parseInt(place)) {
                    return false;
                }
            }
        }
        for (let j = 0; j < zone._objects.length; j++) {
            if(zone._objects[j].type === "group") {
                if(!isPlaceFreeByZone(place, zone._objects[j])) {
                    return false;
                }
            }
        }
        return true;
    }
    
    function isPlaceFree(place, items) {
        for (let aux = 0; aux < items.length; aux++) {
            let zone = items[aux];
            if (zone.type === "group") {
                if(!isPlaceFreeByZone(place, zone))
                {
                    return false;
                }
            }
        }
        return true;
    }
    
    return {
        arePlacesFree: function (firstPlace, increment, numPlaces, items) {
            let places = [];
            for (let i = firstPlace, j = 0; j < numPlaces; i += increment, j++) {
                if(!isPlaceFree(i, items)) {
                    places.push(i);
                }
            }
            return places;
        },
        deleteGuestZone: function (eventId, spaceId, zoneId, guestId, preferedPosition) {
            logService.debug("deleteGuestZone: " + eventId + " " + spaceId + " " + zoneId + " " + guestId + " " + preferedPosition);
            Restangular.one('Events', eventId)
                .one('Spaces', spaceId)
                .one('Zones', zoneId)
                .one('Guests', guestId)
                .one('Place', preferedPosition)
                .remove().then(function (response) {
            });
        }
    };
}]);
